<template>
  <div>
    <b-modal v-if="modalActive" :active.sync="modalActive" has-modal-card @close="setPreferences({isWelcome: 'false'})">
        <WelcomeSlide />
    </b-modal>
    <div class="content-wrap">
      <SideMenu/>
      <transition name="slide-left" mode="out-in">
          <router-view class="content-area child"
            :variableId="this.$route.query.vID"
          ></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import SideMenu from "./DashboardSideMenu.vue"
import WelcomeSlide from "./TheWelcomeSlide"

export default {
  components: { SideMenu, WelcomeSlide },
  data() {
    return {
      modalActive: false
    }
  },
  computed: {
    ...mapState({
      groupId: state => state.groups.selected
    }),
    ...mapGetters({
        defaultGroup: 'groups/defaultGroup'
    })
  },
  mounted() {
    if (this.$store.state.preferences.isWelcome == "true"){
      this.modalActive = true
      this.$store.commit('preferences/setPreferences', {isWelcome: 'false'})
    }else {
      this.modalActive = false
    }
    const grp = this.$route.params.groupId || this.defaultGroup
    this.selectGroup(grp)
    .catch(() => { 
      this.$buefy.toast.open({
        duration: 7000,
        message: this.$t('app.dashboard.graph.error_warning'),
        position: "is-top",
        type: "is-danger"
      })
      return Promise.resolve()
    })
  },
  methods: {
    ...mapActions({
      selectGroup: 'groups/selectGroup',
      getGroup: 'groups/getGroup'
    }),
    ...mapMutations({
      'setPreferences': 'preferences/setPreferences'
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (from.path !== to.path && from.query == to.query) {
        const q = Object.assign({
          since: from.query.since,
          until: from.query.until
        }, to.query);
        const to_ = Object.assign({}, to)
        to_.query = q;
        this.$router.replace(to_)
    }
    next()
  }
}
</script>
<style scoped>
.content-wrap {
  display: flex;
}
.content-area {
  padding: 35px 5%;
  width: calc(100% - 220px);
  background: #f5f5f5;
}

.content-box {
  width: 100%;
  background: #fff;
  margin: 35px 0;
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* transition */
.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-to {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.child {
  position: relative;
  /* transition: all .5s cubic-bezier(.55,0,.1,1); */
  transition: all .3s ease-out;
}
</style>
